import CommunicationsMessageLogListRouteBase from 'garaje/helpers/communications/message-log/list/route-base';

export default class CommunicationsMessageLogLisLocationOverviewRoute extends CommunicationsMessageLogListRouteBase {}
